import OfferFeatures from './OfferFeatures'

export default OfferFeatures
